(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5973],{

/***/ 48244:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/design-ideas/countertop-designs",
      function () {
        return __webpack_require__(84970);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 84970:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(6212);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4492);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35005);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31955);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83346);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46066);
/* harmony import */ var react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52681);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_6__);










function CounterTopDesigns() {
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [selectedImage, setSelectedImage] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [isReadMore, setIsReadMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const [isExpertTalkClicked, setIsExpertTalkClicked] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [relatedBlogData, setRelatedBlogData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [touch, setTouch] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        name: "",
        number: "",
        pincode: js_cookie__WEBPACK_IMPORTED_MODULE_2__/* ["default"].get */ .Z.get("pincode"),
        error: "",
        loading: false
    });
    const handleShow = (image)=>{
        setSelectedImage(image);
        setShow(true);
    };
    var requestOptions = {
        method: "GET"
    };
    const handleClose = ()=>setShow(false);
    const submitGetInTouch = async ()=>{
        const namee = touch.name;
        const no = touch.number;
        const pin = touch.pincode;
        if (!namee || !no || !pin) {
            setTouch({
                ...touch,
                error: "All fields are required"
            });
        } else if (String(pin).length != 6) {
            setTouch({
                ...touch,
                error: "Invalid Pincode"
            });
        } else {
            setTouch({
                ...touch,
                error: "",
                loading: true
            });
            let response = await getIntouch({
                name: namee,
                phone: no,
                pincode: pin
            });
            if (response === null || response === void 0 ? void 0 : response.message) {
                localStorage.setItem("leadfilled", true);
                swal(response === null || response === void 0 ? void 0 : response.message);
                setTouch({
                    ...touch,
                    error: "",
                    loading: false
                });
            } else {
                swal(response.data.get_in_touch.msg);
                // setGetInTouch(false)
                setTouch({
                    name: "",
                    number: "",
                    error: "",
                    loading: false
                });
                setIsExpertTalkClicked(false);
            }
        }
    };
    const settings = {
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: false,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    };
    const settings2 = {
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        centerMode: false,
        autoplaySpeed: 3000,
        arrows: true,
        dots: false,
        centerPadding: "0px",
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 641,
                settings: {
                    arrows: true,
                    centerMode: false,
                    slidesToShow: 1
                }
            }
        ]
    };
    const faqs = [
        {
            question: "What aspects should I consider while planning a bathroom?",
            answer: "Consider the available area, the desired overall style, ventilation, lighting, storage needs, and ventilation. Do not forget to infuse your flair into the design as well but give priority to functionality also."
        },
        {
            question: "Can a small bathroom be made to appear bigger?",
            answer: "Yes, you can make a small bathroom look bigger with a few smart design choices. Using light colours like white or soft pastels can create an open feel. Large mirrors can reflect light and give an illusion of space. Opt for large tiles with fewer grout lines and install proper lighting. Keeping the d\xe9cor minimal and using wall-mounted fixtures also helps to make the room feel more spacious."
        },
        {
            question: "What are some of the recent trends in bathroom decor?",
            answer: "Popular trends in bathroom d\xe9cor focus on creating a spa-inspired ambiance with neutral tones, natural elements, and soft lighting. Patterned or textured wall tiles paired with stylish flooring and well-placed mirrors are commonly seen. Additionally, glossy marble tiles for walls combined with matte finish tiles for floors and metallic d\xe9cor elements, have become popular choices, offering a mix of elegance and contemporary style."
        },
        {
            question: "How to select the best flooring for my bathroom?",
            answer: "Select flooring materials that offer resistance against moisture, such as vitrified tiles or ceramic tiles. Orientbell Tiles has a collection of anti-skid tiles that will be ideal for a bathroom. Along with the practical side, consider your design choices, maintenance requirements, and budget."
        },
        {
            question: "Which type of lighting works the best in a bathroom?",
            answer: "You can go ahead with the combination of ambient, and accent lighting to make a bathroom seem cosy and well-lit. "
        },
        {
            question: "Is it better to work with an expert designer or can I design my own bathroom?",
            answer: "Hiring a designing expert brings experience, saves time, and brings a consistent style. However, if you are on a tight budget, creating your bathroom design is achievable with careful planning and study."
        }
    ];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        getRelatedBlogs();
    }, []);
    const handleToggle = (index)=>{
        setActiveIndex(activeIndex === index ? null : index);
    };
    const toggleReadMore = ()=>{
        setIsReadMore(!isReadMore);
    };
    const text = "Your countertops play an important role in shaping the functionality and aesthetics of your space, be it your kitchen or bathroom. The right countertop design can transform your home and make everyday tasks easier. From modern styles to timeless classics, our countertop design ideas will surely leave a lasting impression.\nWhether you're looking for kitchen countertop design ideas or bathroom countertop designs to enhance the look and functionality, we’ve got you covered!  We have options to match your needs for both the kitchen and bathroom. Browse our collection of countertop ideas that combine style with practicality. With these options, your space will not only be purposeful but will truly stand out.\n              ";
    const maxChars = 300;
    const previewText = text.substring(0, maxChars);
    const remainingText = text.substring(maxChars);
    const getRelatedBlogs = async ()=>{
        // try{
        let blogQuery = router.asPath.split("/")[router.asPath.split("/").length - 1];
        //   let apiresult= await axios.get(`https://proxy.orientbell.com/blog/wp-json/post/v2/category/term=${blogQuery}`)
        //      console.log("RESULT OF BLOGS ", apiresult)
        //     setRelatedBlogData(apiresult)
        // }catch(err){
        //   console.log("Error in fetching blogs", err)
        // }
        fetch("".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* ["default"].HEADLESS_BASE_URL */ .Z.HEADLESS_BASE_URL, "/blog/wp-json/post/v2/category/term=").concat(blogQuery), requestOptions).then((response)=>response.text()).then((result)=>{
            setRelatedBlogData(JSON.parse(result));
        }).catch((error)=>console.log("error", error));
    };
    const scrollToElement = (id)=>{
        const element = document.getElementById(id);
        if (element) {
            const headerOffset = 100; // Adjust based on your header height
            const elementPosition = element.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
            window.scrollTo({
                top: offsetPosition,
                behavior: "smooth"
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_6___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "title",
                        content: "10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Explore 10+ stunning countertop designs for kitchens and bathrooms at Orientbell. Find modern kitchen countertop designs ideas for every style and budget. "
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                itemListElement: [
                                    {
                                        "@type": "ListItem",
                                        position: 1,
                                        name: "Home",
                                        item: "https://staging.orientbell.com/"
                                    },
                                    {
                                        "@type": "ListItem",
                                        position: 2,
                                        name: "Design Ideas",
                                        item: "https://staging.orientbell.com/design-ideas/"
                                    },
                                    {
                                        "@type": "ListItem",
                                        position: 3,
                                        name: "Countertop Designs",
                                        item: "https://staging.orientbell.com/design-ideas/countertop-designs"
                                    }
                                ]
                            })
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                        type: "application/ld+json",
                        dangerouslySetInnerHTML: {
                            __html: JSON.stringify({
                                "@context": "https://schema.org",
                                "@type": "WebPage",
                                url: "design-ideas/countertop-designs",
                                headline: "",
                                breadcrumb: "Home > Design Ideas > Countertop Designs",
                                name: "10+ Stylish Countertop Designs | Modern Kitchen Countertop Designs",
                                description: "Explore 10+ stunning countertop designs for kitchens and bathrooms at Orientbell. Find modern kitchen countertop designs ideas for every style and budget."
                            })
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                class: "designpage-section",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    class: "container",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/",
                                    children: "Home"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/design-ideas",
                                    children: "Design Ideas"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Breadcrumb__WEBPACK_IMPORTED_MODULE_7__/* ["default"].Item */ .Z.Item, {
                                    href: "/design-ideas/countertop-designs",
                                    children: "Countertop Designs"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            class: "designpage-heading-bx padding-spacing",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: "Counter Top Designs"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "description-text",
                                    children: [
                                        previewText,
                                        !isReadMore && text.length > maxChars && "...",
                                        isReadMore && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            children: remainingText
                                        }),
                                        text.length > maxChars && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            onClick: toggleReadMore,
                                            children: isReadMore ? "Read Less" : "Read More"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            class: "desi-page-category-col-bx",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    class: "design-category-head-row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_slick__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        ...settings2,
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#Kitchen Countertop",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        scrollToElement("Kitchen Countertop");
                                                    },
                                                    children: "Kitchen Countertop Design"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#Bathroom Countertop Design",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        scrollToElement("Bathroom Countertop Design");
                                                    },
                                                    children: "Bathroom Countertop Design"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                    href: "#Other",
                                                    onClick: (e)=>{
                                                        e.preventDefault();
                                                        scrollToElement("Other");
                                                    },
                                                    children: "Other Countertop Design"
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    class: "design-category-col-right",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "designpage-category-wrap",
                                            id: "Kitchen Countertop",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "designpage-heading-row",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-left",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                children: "Kitchen Countertop Designs"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-right",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://staging.orientbell.com/design-ideas/countertop-designs",
                                                                children: "View all"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    class: "designpage-category-row padding-spacing",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Black_kitchen_countertop_design_luxurious_white_kitchen.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Black_kitchen_countertop_design_luxurious_white_kitchen.webp",
                                                                        alt: "Black kitchen countertop design luxurious white kitchen"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Modern_kitchen_with_a_striking_dark_stone_countertop..webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Modern_kitchen_with_a_striking_dark_stone_countertop..webp",
                                                                        alt: "Modern kitchen with a striking dark stone countertop."
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_design_with_classic_stove_and_modern_sink.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_design_with_classic_stove_and_modern_sink.webp",
                                                                        alt: "Stylish countertop design with classic stove and modern sink"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_designs_pair_with_stylish_sink_and_cabinets.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Stylish_countertop_designs_pair_with_stylish_sink_and_cabinets.webp",
                                                                        alt: "Stylish countertop designs pair with stylish sink and cabinets"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Luxurious_matte_brown_countertop_design_paired_with_neutral_cabinetry.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Luxurious_matte_brown_countertop_design_paired_with_neutral_cabinetry.webp",
                                                                        alt: "Luxurious matte brown countertop design paired with neutral cabinetry"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Luxury_countertop_design_featuring_with_built-in_sink_and_gas_stove.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Luxury_countertop_design_featuring_with_built-in_sink_and_gas_stove.webp",
                                                                        alt: "Luxury countertop design featuring with built-in sink and gas stove"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_textured_wooden_cabinetry.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_textured_wooden_cabinetry.webp",
                                                                        alt: "Countertop design paired with textured wooden cabinetry"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "designpage-category-wrap",
                                            id: "Bathroom Countertop Design",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "designpage-heading-row",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-left",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                children: "Bathroom Countertop Designs"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-right",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://staging.orientbell.com/design-ideas/countertop-designs",
                                                                children: "View all"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                " ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    class: "designpage-category-row padding-spacing",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_wooden_vanity_and_marble_flooring.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Countertop_design_paired_with_wooden_vanity_and_marble_flooring.webp",
                                                                        alt: "Countertop design paired with wooden vanity and marble flooring"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://staging.orientbell.com/media/design-images/Counter%20Top/Sleek_kitchen_setup_featuring_elegant_countertop_design.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://staging.orientbell.com/media/design-images/Counter%20Top/Sleek_kitchen_setup_featuring_elegant_countertop_design.webp",
                                                                        alt: "Sleek kitchen setup featuring elegant countertop design"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            class: "designpage-category-wrap",
                                            id: "Other",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "designpage-heading-row",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-left",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                                children: "Other Countertop Designs"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "designpage-heading-right",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "https://staging.orientbell.com/design-ideas/countertop-designs",
                                                                children: "View all"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    class: "designpage-category-row padding-spacing",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Sophisticated_countertop_design_featuring_glossy_black_surface.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Sophisticated_countertop_design_featuring_glossy_black_surface.webp",
                                                                        alt: "Sophisticated countertop design featuring glossy black surface"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Office_space_with_a_sleek_white_countertop_on_conference_table_and_modern_chairs.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Office_space_with_a_sleek_white_countertop_on_conference_table_and_modern_chairs.webp",
                                                                        alt: "Office space with a sleek white countertop on conference table and modern chairs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Elegant_black_countertop_design_with_a_glossy_finish_featuring_a_modern_dining_table_setup.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Elegant_black_countertop_design_with_a_glossy_finish_featuring_a_modern_dining_table_setup.webp",
                                                                        alt: "Elegant black countertop design with a glossy finish, featuring a modern dining table setup"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            class: "designpage-category-col",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-figure",
                                                                    onClick: ()=>handleShow("https://orientbell.com/media/design-images/Counter Top/Elegant_countertop_design_with_Wooden_bar_stools.webp"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                        src: "https://orientbell.com/media/design-images/Counter Top/Elegant_countertop_design_with_Wooden_bar_stools.webp",
                                                                        alt: "Elegant countertop design with Wooden bar stools"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    class: "designpage-text",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                                                        class: "talk-expert-btn talk-to-expert-design-page",
                                                                        onClick: ()=>{
                                                                            setIsExpertTalkClicked(true);
                                                                        },
                                                                        children: "Talk to Expert"
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "tile-related-blog",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "title",
                                    children: "Related Blogs"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "designpage-relatedpost-row",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                        ...settings,
                                        children: relatedBlogData === null || relatedBlogData === void 0 ? void 0 : relatedBlogData.map((obj, index)=>{
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "related-blog-col",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "blog-figure",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            href: obj.permalink,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: obj.image,
                                                                loading: "lazy",
                                                                alt: "Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "blog-text",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "listingDate",
                                                                children: obj.date
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "listingHead",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                    href: obj.permalink,
                                                                    rel: "nofollow",
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        dangerouslySetInnerHTML: {
                                                                            __html: obj.title
                                                                        }
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                className: "listingText",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        children: [
                                                                            " ",
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                dangerouslySetInnerHTML: {
                                                                                    __html: obj.content.slice(0, -11)
                                                                                }
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                        className: "listingButton",
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                            href: obj.permalink,
                                                                            rel: "nofollow",
                                                                            children: "Read More"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                className: "image-zoom-view-modal",
                show: show,
                autoFocus: true,
                onHide: handleClose,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                            closeButton: true
                        }),
                        selectedImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            height: "400px",
                            src: "".concat(selectedImage)
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                show: isExpertTalkClicked,
                className: "pincode-popup-bx expert_assistance_modal ask-question-popup",
                onHide: ()=>{
                    // setTimePopup(false)
                    // setGetInTouch(false)
                    setIsExpertTalkClicked(false);
                // localStorage.setItem('leadSkiped',true)
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Dialog */ .Z.Dialog, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Header */ .Z.Header, {
                            closeButton: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Title */ .Z.Title, {
                                children: "Get in touch with our tile expert"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "ask-question-section",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "expert-fig-bx",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: "/new-tareek.jpg"
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_8__/* ["default"].Body */ .Z.Body, {
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: "Ask Tile Expert"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: "Let Experts Help You In Buying Process"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            onSubmit: (e)=>{
                                                e.preventDefault();
                                                submitGetInTouch();
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicEmail",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Label */ .Z.Label, {
                                                            children: "Name"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Control */ .Z.Control, {
                                                            type: "text",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    name: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Label */ .Z.Label, {
                                                            children: "Mobile"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    number: "".concat(touch.countryCode || "").concat(e.target.value)
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Group */ .Z.Group, {
                                                    className: "mb-3",
                                                    controlId: "formBasicPassword",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Label */ .Z.Label, {
                                                            children: "Pincode"
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_9__/* ["default"].Control */ .Z.Control, {
                                                            type: "number",
                                                            value: touch.pincode,
                                                            onChange: (e)=>{
                                                                setTouch({
                                                                    ...touch,
                                                                    pincode: e.target.value
                                                                });
                                                            }
                                                        })
                                                    ]
                                                }),
                                                touch.error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "error text-danger",
                                                    children: touch.error
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                    variant: "primary",
                                                    type: "submit",
                                                    disabled: touch.loading,
                                                    style: {
                                                        width: "100%"
                                                    },
                                                    children: touch.loading ? "Submitting" : "Submit"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CounterTopDesigns);


/***/ }),

/***/ 52681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76792);
/* harmony import */ var _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15094);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const Breadcrumb = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  className,
  listProps = {},
  children,
  label = 'breadcrumb',
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'nav',
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_3__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    "aria-label": label,
    className: className,
    ref: ref,
    ...props,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("ol", {
      ...listProps,
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, listProps == null ? void 0 : listProps.className),
      children: children
    })
  });
});
Breadcrumb.displayName = 'Breadcrumb';
/* harmony default export */ __webpack_exports__["Z"] = (Object.assign(Breadcrumb, {
  Item: _BreadcrumbItem__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z
}));

/***/ }),

/***/ 15094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13551);
/* harmony import */ var _ThemeProvider__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(76792);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);





const BreadcrumbItem = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.forwardRef(({
  bsPrefix,
  active = false,
  children,
  className,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: Component = 'li',
  linkAs: LinkComponent = _restart_ui_Anchor__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
  linkProps = {},
  href,
  title,
  target,
  ...props
}, ref) => {
  const prefix = (0,_ThemeProvider__WEBPACK_IMPORTED_MODULE_4__/* .useBootstrapPrefix */ .vE)(bsPrefix, 'breadcrumb-item');
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Component, {
    ref: ref,
    ...props,
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()(prefix, className, {
      active
    }),
    "aria-current": active ? 'page' : undefined,
    children: active ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(LinkComponent, {
      ...linkProps,
      href: href,
      title: title,
      target: target,
      children: children
    })
  });
});
BreadcrumbItem.displayName = 'BreadcrumbItem';
/* harmony default export */ __webpack_exports__["Z"] = (BreadcrumbItem);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7767,4585,7615,6212,2770,9774,2888,179], function() { return __webpack_exec__(48244); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);